import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full text-center relative z-10 bg-blue-10 mb-8 pb-8 pt-12" }
const _hoisted_2 = { class: "flex flex-col justify-end mt-8 lg:mt-0 lg:h-1/4 lg:min-h-300" }
const _hoisted_3 = {
  key: 0,
  class: "my-4 lg:my-6 text-2xl font-medium md:text-3xl lg:text-3xl"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "text-left mx-3 mb-6 lg:m-0 h-2/4 mb-12 pb-18" }
const _hoisted_6 = { class: "flex mx-auto justify-center align-start" }
const _hoisted_7 = {
  key: 0,
  class: "mb-4 text-lg md:text-2xl"
}

import { UiCard, SvgIcon } from '@/ui-kit';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthContainer',
  props: {
    title: null,
    subTitle: null,
    cardTitle: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(SvgIcon), {
        name: "logo",
        class: "mx-auto w-20 h-20 md:w-32 md:h-32 lg:w-36 lg:h-36"
      }),
      (__props.title)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true),
      (__props.subTitle)
        ? (_openBlock(), _createElementBlock("h1", {
            key: 1,
            class: "mb-4 -mt-4 text-xl font-medium",
            innerHTML: __props.subTitle
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "outerTopBlock")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "leftBlock"),
        _createVNode(_unref(UiCard), {
          theme: "white",
          class: "max-w-xl w-full auth__card"
        }, {
          default: _withCtx(() => [
            (__props.cardTitle)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(__props.cardTitle), 1))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }),
        _renderSlot(_ctx.$slots, "rightBlock")
      ]),
      _renderSlot(_ctx.$slots, "outerBlock")
    ])
  ]))
}
}

})